import { useMutation, MutationHookOptions } from '@apollo/client';
import MUTATION from '../operations/UploadPaymentStatusFile.graphql';
import { Mutation, MutationuploadPaymentStatusFileArgs } from '../../__generated__/globalTypes';

export const useUploadPaymentStatusFileMutation = (
  options?: MutationHookOptions<Mutation, MutationuploadPaymentStatusFileArgs>
) => {
  const [callUploadPaymentStatusFile, result] = useMutation<Mutation, MutationuploadPaymentStatusFileArgs>(
    MUTATION,
    options
  );

  return { callUploadPaymentStatusFile, ...result };
};

export type UploadPaymentStatusFileMutationFunction = Mutation['uploadPaymentStatusFile'];
